export default class ItemPermiso {
    IdElemento: number;
    Elemento: string;
    ControlTotal: boolean;
    Ver: boolean;
    Nuevo: boolean;
    Modificar: boolean;
    Eliminar: boolean;

    constructor() {
        this.IdElemento = 0;
        this.Elemento = "";
        this.ControlTotal = false;
        this.Ver = false;
        this.Nuevo = false;
        this.Modificar = false;
        this.Eliminar = false;
    };
};
